"use client"

import React from "react"

/**
 * Marks something as happening right now, so a live simulation is findable
 * without hunting. Deliberately loud while the feature is being rolled out.
 */
export function LiveIndicator({
  label = "LIVE",
  size = "md",
}: {
  label?: string
  size?: "sm" | "md" | "lg"
}) {
  const sizing =
    size === "lg"
      ? "gap-2 px-3 py-1 text-sm"
      : size === "sm"
        ? "gap-1.5 px-1.5 py-0.5 text-[10px]"
        : "gap-1.5 px-2 py-0.5 text-xs"

  return (
    <span
      aria-label="Live"
      className={`inline-flex shrink-0 items-center rounded-full bg-coval-danger font-bold uppercase tracking-wide text-coval-text-on-contrast ${sizing}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-coval-text-on-contrast opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-coval-text-on-contrast" />
      </span>
      {label}
    </span>
  )
}
